import Glide from '@glidejs/glide'

export const HeaderHome = () => {
  const $carousel = document.querySelector('.glide.glide-header-home')

  if (!$carousel) return

  const HeaderHomeCarousel = new Glide($carousel, {
    autoplay: 6000,
    focusAt: 0,
    gap: 0,
    hoverpause: false,
    perView: 1,
    type: 'carousel',
  }).mount()
}

export const ProductsHome = () => {
  const $carousel = document.querySelector('.glide.glide-products')
  const $carouselSingle = document.querySelector('.glide.glide-products-single')

  if (!$carousel) return

  const carousel = new Glide($carousel, {
    autoplay: false,
    focusAt: 0,
    gap: 10,
    hoverpause: false,
    perView: 1,
    type: 'carousel',
  }).mount()

  const carouselSingle = new Glide($carouselSingle, {
    autoplay: false,
    focusAt: 0,
    gap: 10,
    hoverpause: false,
    perView: 1,
    type: 'carousel',
  }).mount()
}

export const Testimonials = () => {
  const $carousel = document.querySelector('.glide.glide-testimonials')

  if (!$carousel) return

  const TestimonialsCarousel = new Glide($carousel, {
    autoplay: 6000,
    focusAt: 0,
    gap: 20,
    hoverpause: false,
    perView: 3,
    type: 'carousel',
    breakpoints: {
      1023: {
        perView: 2
      },
      767: {
        perView: 1
      },
    }
  }).mount()
}
